import React from "react";
import { Box, TextField, Typography } from "@mui/material";

const Descripcion = ({ descripcionProforma, onDescripcionChange }) => {
  return (
    <Box>
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 2, color: "#1565C0" }}>
        Descripción del Servicio o Equipos
      </Typography>

      <TextField
        label="Descripción"
        fullWidth
        multiline
        minRows={4}
        value={descripcionProforma}
        onChange={(e) => onDescripcionChange(e.target.value)}
        placeholder="Ingrese la descripción general de la proforma"
      />
    </Box>
  );
};

export default Descripcion;